/**
 * Revoga no servidor o token que está saindo (PUB-04). Best-effort: nunca
 * lança, e quem chama já apagou a sessão local antes. Se o servidor estiver
 * fora, lento ou ainda sem a rota, o logout local continua valendo.
 */

export type ServerLogoutPath = "/auth/logout" | "/customer-auth/logout";

const SERVER_LOGOUT_TIMEOUT_MS = 4000;

export async function revokeServerSession(
  path: ServerLogoutPath,
  token: string
): Promise<void> {
  if (!token || typeof fetch !== "function") return;

  const controller = typeof AbortController === "function" ? new AbortController() : null;
  const timer = controller
    ? setTimeout(() => controller.abort(), SERVER_LOGOUT_TIMEOUT_MS)
    : null;

  try {
    // Import tardio: `services/http` importa `lib/auth`, que chama esta função.
    const { buildFormUrl } = await import("../services/http");
    await fetch(buildFormUrl(path), {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      // Mantém a requisição viva se a página navegar logo em seguida.
      keepalive: true,
      signal: controller?.signal,
    });
  } catch {
    /* best-effort: a sessão local já foi encerrada */
  } finally {
    if (timer) clearTimeout(timer);
  }
}
